import React,{useState,useEffect} from 'react';
import { Link,useParams } from 'react-router-dom';
import { addItemsToCart } from "../actions/cartAction";
import { Swiper, SwiperSlide } from "swiper/react";
// import ReactStars from 'react-rating-stars-component';
import MetaData from '../components/MetaData.js';
import { clearErrors, getProductDetails, getProduct, newReview } from "../actions/productAction";
import { useSelector, useDispatch } from "react-redux";
import Loader from "../components/Loader.js";
import { useAlert } from "react-alert";
import { Rating } from "@material-ui/lab";
import { NEW_REVIEW_RESET } from "../constants/productConstant";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";

import { Navigation,FreeMode,Thumbs } from "swiper";


const ReviewCard = ({review}) =>{

    const options = {
        value: review?.rating,
        readOnly: true,
        precision: 0.5,
    };

    return(
    <div className="single-reviews">
        <div className="comment-author">
            <img src="../assets/images/author/author-1.png" width="100" height="100" alt="User" />
        </div>
        <div className="comment-content">
            <div className="author-name-rating">
                <h6 className="name">{review?.name}</h6>
                {/*<div className="review-star">
                    <div className="star" style={{width: '80%'}}></div>
                </div>*/}
                <Rating {...options} />
            </div>
            <span className="date">{String(review?.createdAt).substr(0, 10)}</span>
            <p>
                {review?.comment}
            </p>
        </div>
    </div>
    )
}

const ProductDetails = () => {

    const { product, loading, error } = useSelector((state) => state.productDetails);

    const { success, error: reviewError } = useSelector((state) => state.newReview);

    const { products } = useSelector((state) => state.products);

    const { isAuthenticated, user } = useSelector((state) => state.user)

    const [isPurchased, setIsPurchased] = useState(false);


    // const options = {
    //     edit: false,
    //     color: "#dbdbdb",
    //     activeColor: "#f2a100",
    //     size: window.innerWidth < 600 ? 20 : 25,
    //     // value: 2.5,
    //     isHalf: true,
    //     value: product.ratings,
    //     readOnly: true,
    //     precision: 0.5,
    // }
    const options = {
        size: "large",
        value: product?.ratings,
        readOnly: true,
        precision: 0.5,
    };


	const [thumbsSwiper, setThumbsSwiper] = useState(null);
	const dispatch = useDispatch();
	const { id } = useParams();
    const alert = useAlert();
    const [quantity, setQuantity] = useState(1);
    // const [open, setOpen] = useState(false);
    const [rating, setRating] = useState(0);
    const [comment, setComment] = useState("");

    useEffect(() => {
        if (error) {
            alert.error(error);
            dispatch(clearErrors());
        }
        dispatch(getProductDetails(id));
        dispatch(getProduct());
    }, [dispatch, id, error, alert]);


    const increaseQuantity = () => {
        if (product.Stock <= quantity) return;

        const qty = quantity + 1;
        setQuantity(qty);
    };

    const decreaseQuantity = () => {
        if (1 >= quantity) return;

        const qty = quantity - 1;
        setQuantity(qty);
    };

    const addToCartHandler = () => {
        dispatch(addItemsToCart(id, quantity));
        alert.success("Item Added To Cart");
    };

    const reviewSubmitHandler = (e) => {
        e.preventDefault();

        if (!comment.trim()) {
            // Show an error if the comment is empty
            alert.error("Please enter a comment before submitting.");
            return;
        }

        const myForm = new FormData();

        myForm.set("rating", rating);
        myForm.set("comment", comment);
        myForm.set("productId", id);

        dispatch(newReview(myForm));

        // setOpen(false);
    };

    useEffect(() => {
        if (error) {
          alert.error(error);
          dispatch(clearErrors());
        }

        if (reviewError) {
          alert.error(reviewError);
          dispatch(clearErrors());
        }

        if (success) {
          alert.success("Review Submitted Successfully");
          dispatch({ type: NEW_REVIEW_RESET });
        }
        dispatch(getProductDetails(id));
        dispatch(getProduct());
    }, [dispatch, id, error, alert, reviewError, success]);

    // useEffect(() => {
    //     if (error) {
    //         alert.error(error);
    //         dispatch(clearErrors());
    //     }
    //     dispatch(getProductDetails(id));
        
    // }, [dispatch, id, error, alert]);


    useEffect(() => {
        const checkPurchaseStatus = async () => {
          try {
            const response = await fetch("/api/v1/check-purchase", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({ userId: user?._id, productId: product?._id }),
            });
            const data = await response.json();
            if (data.isPurchased) {
              setIsPurchased(true);
            } else {
              setIsPurchased(false);
            }
          } catch (error) {
            console.error("Error checking purchase status:", error);
          }
        };

        checkPurchaseStatus();
    }, [product?._id, user?._id]);

    const [localizedPrice, setLocalizedPrice] = useState(null);
    const [currencySymbol, setCurrencySymbol] = useState("£");
    const [isLoading, setIsLoading] = useState(true);

    // Country-to-Currency mapping with exchange rates
    // const countryToCurrency = {
    //     PK: { symbol: "₨", rate: 380 }, // Example rate: 1 GBP = 380 PKR
    //     US: { symbol: "$", rate: 1.2 }, // Example rate: 1 GBP = 1.2 USD
    //     FR: { symbol: "€", rate: 1.15 }, // Example rate: 1 GBP = 1.15 EUR
    //     IN: { symbol: "₹", rate: 100 }, // Example rate: 1 GBP = 100 INR
    //     GB: { symbol: "£", rate: 1 }, // Base currency: GBP
    // };

    const [countryToCurrency, setCountryToCurrency] = useState({
      PK: { symbol: "₨", currencyCode: "PKR", rate: null },
      US: { symbol: "$", currencyCode: "USD", rate: null },
      FR: { symbol: "€", currencyCode: "EUR", rate: null },
      IN: { symbol: "₹", currencyCode: "INR", rate: null },
      GB: { symbol: "£", currencyCode: "GBP", rate: null },
      AE: { symbol: "AED", currencyCode: "AED", rate: null },
      CN: { symbol: "CNY", currencyCode: "CNY", rate: null },
      SA: { symbol: "SAR", currencyCode: "SAR", rate: null },
    });

    const API_URL = "https://open.er-api.com/v6/latest/GBP"; // Replace with your API endpoint

    const fetchExchangeRates = async () => {
      try {
        const response = await fetch(API_URL);
        if (!response.ok) throw new Error("Failed to fetch exchange rates");
        const data = await response.json();
        console.log(data)
        setCountryToCurrency((prev) => {
          const updatedCurrencies = { ...prev };

          Object.keys(updatedCurrencies).forEach((country) => {
            const currencyCode = updatedCurrencies[country].currencyCode;
            const rate = data.rates[currencyCode];
            if (rate) {
              updatedCurrencies[country].rate = rate;
            }
          });

          return updatedCurrencies;
        });
      } catch (error) {
        console.error("Error fetching exchange rates:", error);
      }
    };

    // Fetch user's country using their IP address
    const fetchUserCountry = async () => {
      try {
        const response = await fetch("https://get.geojs.io/v1/ip/country.json");
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();
        // console.log(data)
        const countryCode = data.country || "GB"; // Default to GB
        return countryCode;
      } catch (error) {
        console.error("Error fetching user country:", error);
        return "GB"; // Fallback to GB
      }
    };


    // Convert price based on the user's country and exchange rate
    const convertPriceByCountry = async () => {
  setIsLoading(true); // Show loading state

  await fetchExchangeRates();
  const countryCode = await fetchUserCountry();
  const currencyInfo = countryToCurrency[countryCode] || countryToCurrency["GB"]; // Default to GBP

  if (currencyInfo.rate) {
    setCurrencySymbol(currencyInfo.symbol);
    const convertedPrice = (product?.price * currencyInfo.rate).toFixed(2);
    setLocalizedPrice(convertedPrice);
  } else {
    console.error("Exchange rate not available for country:", countryCode);
    setCurrencySymbol("£"); // Default to GBP symbol
    setLocalizedPrice(product?.price.toFixed(2)); // Default price in GBP
  }

  setIsLoading(false); // Hide loading state
};

    useEffect(() => {
        if (product?.price) {
            convertPriceByCountry();
        }
    }, [product]);

    const [isExpanded, setIsExpanded] = useState(false);

  const toggleReadMore = () => {
    setIsExpanded(!isExpanded);
  };

  const description = product?.tutorDesc || "";
  const words = description.split(" ");
  const truncatedDescription = words.slice(0, 60).join(" ") + (words.length > 60 ? "..." : "");


	return (
        <>
        {
            loading? ( <Loader />) :( 
        
       
		<>
		
				<MetaData title={`${product?.name} - Ecampus`} />
			
			{/*<!-- Product Details Section Start -->*/}
    <div className="section section-padding-02">
        <div className="container">
           {/* <!-- Product Section Wrapper Start -->*/}
            <div className="py-5">
                <div className="row py-3 mt-2">

                    <div className="col-lg-4">
                        {/*<!-- Product Details Images Start -->*/}
                        <div className="product-details-images">
                            {/*<!-- Details Gallery Images Start -->*/}
                            <div className="details-gallery-images" id="img-container">
                                <div className="swiper-container">
                                <Swiper
                                        style={{
                                          // "--swiper-navigation-color": "#fff",
                                          // "--swiper-pagination-color": "#fff",
                                          "marginBottom" : '10px',
                                        }}
                                        loop={true}
                                        spaceBetween={10}
                                        navigation={true}
                                        thumbs={{ swiper: thumbsSwiper && !thumbsSwiper.destroyed ? thumbsSwiper : null }}
                                        modules={[FreeMode, Navigation, Thumbs]}
                                        className="mySwiper2"
                                      >
                                       {
                                        product.images && product.images.map((item, i) => (
                                        <SwiperSlide key={i}>
                                            <div className="swiper-slide">
                                                <div className="single-img">
                                                    <img src={item.url} alt="Product Image" />
                                                </div>
                                            </div>
                                        </SwiperSlide>
                                        ))
                                     	}

                                    </Swiper>

                                </div>
                            </div>


                            {/*<!-- Details Gallery Images End -->*/}

                            {/*<!-- Details Gallery Thumbs Start -->*/}
                            {/*<div className="details-gallery-thumbs">
                                <div className="swiper-container">
                                <Swiper
                                        onSwiper={setThumbsSwiper}
                                        loop={true}
                                        spaceBetween={10}
                                        slidesPerView={4}
                                        freeMode={true}
                                        watchSlidesProgress={true}
                                        modules={[FreeMode, Navigation, Thumbs]}
                                        className="mySwiper"
                                      >
                                      	{
                                        product.images && product.images.map((item, i) => (

                                        <SwiperSlide  key={i}>
                                                <img src={item.url} alt="Product Thumbnail" />
                                        </SwiperSlide>
                                        ))
                                     	}

                                    </Swiper>

                                </div>

                            </div>*/}
                            {/*<!-- Details Gallery Thumbs End -->*/}
                        </div>
                        {/*<!-- Product Details Images End -->*/}
                    </div>
                    <div className="col-lg-4">
                        <div className="single-info d-flex align-items-baseline flex-column">
                            <h3>About Tutor</h3>
                            {/*<div dangerouslySetInnerHTML={{ __html: product?.tutorDesc }}></div>*/}
                            
                              <div className="m-0 tutorDesc"
                                dangerouslySetInnerHTML={{
                                  __html: isExpanded ? description : truncatedDescription,
                                }}
                              ></div>
                              {words.length > 60 && (
                                <small
                                  onClick={toggleReadMore}
                                  style={{color: '#ca0d26', cursor : 'pointer' }}
                                >
                                  {isExpanded ? "Read Less" : "Read More"}
                                </small>
                              )}
                        </div>
                    </div>
                    <div className="col-lg-4">
                        {/*<!-- Product Details Description Start -->*/}
                        <div className="product-details-description" style={{marginTop:"0"}}>
                            {/*<p className="m-0" dangerouslySetInnerHTML={{ __html: product?.description }}></p>*/}

                            <h4 className="product-name text-capitalize">{ product?.name }</h4>
                            <small className="product-topic">{ product?.topic }</small>

                            <div className="review-wrapper align-items-center">
                                {/*<Rating {...options} />*/}
                                {/*<div className="review-star">
                                    <div className="star" style={{width: '80%'}}></div>
                                </div>*/}
                                {/*<p>
                                    <Link className="mx-2" to="#reviews">({product?.numOfReviews} Reviews)</Link>
                                </p>*/}
                            </div>

                            <div className="product-meta">
                                {/*<div className="product-quantity d-inline-flex">
                                    <button onClick={decreaseQuantity} type="button" className="sub">
                                        -
                                    </button>
                                    <input className="text-center" readOnly type="text" value={quantity} />
                                    <button onClick={increaseQuantity} type="button" className="add">
                                        +
                                    </button>
                                </div>*/}
                                <div className="meta-action">
                                    <button disabled={product?.Stock < 1 ? true : false} className="btn btn-dark btn-hover-primary" onClick={addToCartHandler}>
                                        Enroll Now  <span>{`£${product?.price}`}</span>
                                    </button>
                                </div>


                            </div>

                            <div className="price d-block mt-2" style={{fontSize:"medium"}}>
                                {currencySymbol !== "£" && (
                                    <span><i>≈ </i><span className="text-muted">{`${currencySymbol}${localizedPrice}`}</span></span>
                                    )}
                                    {/*<span className="sale-price">{`£${product?.price}`}</span>*/}
                                    {/*<small>{`${currencySymbol} ${localizedPrice}`}</small>*/}
                                </div>

                            <div className="product-info">
                                {/*<div className="single-info">
                                    <span className="lable">SKU:</span>
                                    <span className="value">Ch-256xl</span>
                                </div>*/}
                                <div className="single-info">
                                    <span className="lable">Category:</span>
                                    <span className="value">
                                        <Link to={`/shop/category/${product?.category}`}>{product?.category}</Link>
                                    </span>
                                </div>


                                {/*<div className="single-info">
                                    <span className="lable">Status:</span>
                                    <span className={product?.Stock < 1 ? "text-danger" : "text-success"}
                                            >
                                                {product?.Stock < 1 ? "OutOfStock" : "InStock"}
                                            </span>
                                </div>*/}
                                {/*<div className="accordion accordion-flush productSingleInfo" id="accordionFlushExample">
                                  <div className="accordion-item">
                                    <h2 className="accordion-header">
                                      <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne">
                                        Overview
                                      </button>
                                    </h2>
                                    <div id="flush-collapseOne" className="accordion-collapse collapse" data-bs-parent="#accordionFlushExample">
                                        <div className="accordion-body">
                                            <h5>{product?.speaker}</h5>
                                            <div dangerouslySetInnerHTML={{ __html: product?.description }}>
                                                {product?.description}
                                            </div>
                                        </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2 className="accordion-header">
                                      <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseTwo" aria-expanded="false" aria-controls="flush-collapseTwo">
                                        Type & Duration
                                      </button>
                                    </h2>
                                    <div id="flush-collapseTwo" className="accordion-collapse collapse" data-bs-parent="#accordionFlushExample">
                                        <div className="accordion-body">
                                            <table className="table">
                                              <tbody>
                                                <tr>
                                                  <td><b>Type</b></td>
                                                  <td>{product?.type}</td>
                                                </tr>
                                                <tr>
                                                  <td><b>Duration</b></td>
                                                  <td>{product?.duration}</td>
                                                </tr>
                                                <tr>
                                                  <td><b>Topic</b></td>
                                                  <td>{product?.topic}</td>
                                                </tr>
                                              </tbody>
                                            </table>
                                        </div>
                                    </div>
                                  </div>
                                  <div className="accordion-item">
                                    <h2 className="accordion-header">
                                      <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseThree" aria-expanded="false" aria-controls="flush-collapseThree">
                                        Syllabus
                                      </button>
                                    </h2>
                                    <div id="flush-collapseThree" className="accordion-collapse collapse" data-bs-parent="#accordionFlushExample">
                                        <div className="accordion-body">
                                            <p className="m-0" dangerouslySetInnerHTML={{ __html: product?.syllabus }}></p>
                                        </div>
                                    </div>
                                  </div>
                                </div>*/}

                            </div>
                        </div>
                        {/*<!-- Product Details Description End -->*/}
                    </div>
                </div>

                <div className="my-5 greyBg" style={{borderRadius:"10px"}}>
                    <ul className="nav nav-tabs justify-content-center align-items-center" id="myTab" role="tablist">
                        <li className="nav-item" role="presentation">
                            <button className="nav-link active fw-bold mx-5 px-5 py-3" style={{color: '#322d59'}} id="home-tab" data-bs-toggle="tab" data-bs-target="#home"
                                    type="button" role="tab" aria-controls="home" aria-selected="true"><i className="pe-7s-note2 fw-bolder px-2 fs-5"></i> Course Overview
                            </button>
                        </li>
                        <li className="nav-item" role="presentation">
                            <button className="nav-link fw-bold mx-5 px-5 py-3" style={{color: '#322d59'}} id="profile-tab" data-bs-toggle="tab" data-bs-target="#profile"
                                    type="button" role="tab" aria-controls="profile" aria-selected="false"><i className="pe-7s-notebook fw-bolder px-2 fs-5"></i> Course Syllabus
                            </button>
                        </li>
                    </ul>
                    <div className="tab-content" id="myTabContent">
                        <div className="tab-pane fade show active p-3" id="home" role="tabpanel" aria-labelledby="home-tab">
                            <p className="m-0" dangerouslySetInnerHTML={{ __html: product?.description }}></p></div>
                        <div className="tab-pane fade p-3" id="profile" role="tabpanel" aria-labelledby="profile-tab">
                            <p className="m-0" dangerouslySetInnerHTML={{ __html: product?.syllabus }}></p></div>
                    </div>
                </div>
            </div>
            {/*<!-- Product Section Wrapper End -->*/}
        </div>
    </div>
   {/* <!-- Product Details Section End -->*/}


    <>
    {/*<!-- Product Details tab Section Start -->*/}
    {/*<div className="section section-padding-02">
        <div className="container">
            <!-- Product Details Tabs Start -->
            <div className="product-details-tabs">
                <ul className="nav justify-content-center">
                   
                    <li>
                        <button className="active" data-bs-toggle="tab" data-bs-target="#reviews">
                            Reviews ({product?.numOfReviews})
                        </button>
                    </li>
                </ul>

                <div className="tab-content">
                    <div className="tab-pane fade" id="information">
                        <!-- Information Content Start -->
                        
                        <!-- Information Content End -->
                    </div>
                    <div className="tab-pane fade " id="description">
                        <!-- Description Content Start -->
                       
                        <!-- Description Content End -->
                    </div>
                    <div className="tab-pane fade show active" id="reviews">
                        <!-- Reviews Content Start -->
                        <div className="reviews-content">
                            <!-- Review Comment Start  -->
                            <div className="reviews-comment">
                                <!-- Single Comment Start  -->

                                {product?.reviews && product?.reviews.length > 0 ? ( // Check for array existence AND length
                                    <div className="reviews">
                                        {product?.reviews.map((review) => ( // No need for another check inside map
                                            <ReviewCard key={review._id} review={review} />
                                        ))}
                                    </div>
                                ) : (
                                    <p className="noReviews">No Reviews Yet</p>
                                )}
                                <!-- Single Comment End  -->
                                
                            </div>
                            <!-- Review Comment End  -->

                            <!-- Review Form Start  -->
                            {isAuthenticated && isPurchased ?
                                (
                            <div className="reviews-form">
                                <h3 className="reviews-title">Add a review</h3>

                                <form action="#">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <div className="single-form">
                                                <input type="text" placeholder="Enter your name" />
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="single-form">
                                                <input type="email" placeholder="john.smith@example.com" />
                                            </div>
                                        </div>
                                        <div className="col-md-12">
                                            <div className="review-rating">
                                                <label className="title">Rating:</label>
                                                
                                                <Rating
                                                    onChange={(e) => setRating(e.target.value)}
                                                    value={rating}
                                                    size="large"
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-12">
                                            <div className="single-form">
                                                <textarea value={comment} onChange={(e) => setComment(e.target.value)} placeholder="Write your comments here *"></textarea>
                                            </div>
                                        </div>
                                        <div className="col-md-12">
                                            <div className="single-form">
                                                <button type='submit' onClick={reviewSubmitHandler} className="btn btn-dark btn-hover-primary">
                                                    Submit Review
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </form>

                            </div>
                                    ): null}
                            <!-- Review Form End  -->
                        </div>
                        <!-- Reviews Content End -->
                    </div>
                </div>
            </div>
            <!-- Product Details Tabs End -->
        </div>
    </div>*/}
    {/*<!-- Product Details tab Section End -->*/}
    </>


    {/*<!-- Sale Product Section Start -->*/}
    <div className="section section-padding">
        <div className="container">
            <div className="">
                {/*<!-- Product Wrapper Start -->*/}
                <div className="product-active-02">
                    {/*<!-- Product Top Wrapper Start -->*/}
                    <div className="product-top-wrapper">
                       {/* <!-- Section Title Start -->*/}
                        <div className="section-title">
                            <h2 className="title">Related Courses</h2>
                        </div>
                        {/*<!-- Section Title End -->*/}

                        {/*<!-- Product Menu Start -->*/}
                        
                        {/*<!-- Product Menu End -->*/}

                        
                    </div>
                    {/*<!-- Product Top Wrapper End -->*/}

                    {/*<!-- Product Tabs Content Start -->*/}
                    <div className="product-tabs-content">
                        <div className="tab-content">
                            <div className="tab-pane fade show active" id="tab7">
                                <div className="swiper-container">
                                    <Swiper
                                            slidesPerView={1}
                                            spaceBetween={10}
                                            navigation={true}
                                            breakpoints={{
                                              640: {
                                                slidesPerView: 1,
                                                spaceBetween: 10,
                                              },
                                              768: {
                                                slidesPerView: 2,
                                                spaceBetween: 20,
                                              },
                                              1024: {
                                                slidesPerView: 3,
                                                spaceBetween: 20,
                                              },
                                            }}
                                            modules={[ Navigation ]}
                                            className="mySwiper"
                                          >
                                            {products && products.map((product) => (
                                                        <SwiperSlide key={product._id}>
                                                            <div className='swiper-slide'>
                                                              {/*<div className='single-product'>
                                                                <div className='product-content frontContent'>
                                                                  <h4 className='title'>
                                                                    <Link to={`/product/${product._id}`}>{product.name}</Link>
                                                                  </h4>
                                                                  <div className=''>
                                                                    <p>
                                                                      <span>{product.topic}</span> 
                                                                    </p>
                                                                  </div>
                                                                </div>
                                                                <div className="product-content backContent">
                                                                  <div
                                                                    dangerouslySetInnerHTML={{
                                                                      __html: product?.description
                                                                        ?.split(" ")
                                                                        .slice(0, 20)
                                                                        .join(" ") + (product?.description?.split(" ").length > 10 ? "..." : ""),
                                                                    }}
                                                                  ></div>
                                                                  <ul className='product-meta'>
                                                                    <li>
                                                                      <Link className='action' to={`/product/${product._id}`}>
                                                                        <span>See Details</span>
                                                                      </Link>
                                                                    </li>
                                                                  </ul>
                                                                </div>
                                                              </div>*/}
                                                            <div className="elearningCourses">
                                                    <div className='single-product'>
                                        <div className='product-image'>
                                          <Link to={`/product/${product._id}`}>
                                            <img src={product.images[0].url} alt={product.name}/>
                                          </Link>
                                        </div>
                                        <div className='product-content'>
                                          <h4 className='title'>
                                            <Link to={`/product/${product._id}`}>
                                              {product?.name
                                                ?.split(" ")
                                                .slice(0, 7)
                                                .join(" ") + (product?.name?.split(" ").length > 7 ? "..." : "")}
                                            </Link>
                                          </h4>
                                          <div className="courseContent"
                                            dangerouslySetInnerHTML={{
                                              __html: product?.description
                                                ?.split(" ")
                                                .slice(0, 10)
                                                .join(" ") + (product?.description?.split(" ").length > 10 ? "..." : ""),
                                            }}
                                          ></div>
                                          <Link className='action btn btn-primary' to={`/product/${product._id}`}>
                                            <span>See Details</span>
                                          </Link>
                                        </div>
                                        {/*<div className="product-content backContent">
                                          <div
                                                                    dangerouslySetInnerHTML={{
                                                                      __html: product?.description
                                                                        ?.split(" ")
                                                                        .slice(0, 20)
                                                                        .join(" ") + (product?.description?.split(" ").length > 10 ? "..." : ""),
                                                                    }}
                                                                  ></div>
                                          <ul className='product-meta'>
                                            <li>
                                              <Link className='action' to={`/product/${product._id}`}>
                                                <span>See Details</span>
                                              </Link>
                                            </li>
                                          </ul>
                                        </div>*/}
                                      </div>
                                                </div>
                                                            </div>
                                                        </SwiperSlide>
                                                    ))
                                                }
                                        </Swiper>
                                </div>
                            </div>
                            {/**/}
                        </div>
                    </div>
                    {/*<!-- Product Tabs Content End -->*/}
                </div>
                {/*<!-- Product Wrapper End -->*/}
            </div>
        </div>
    </div>
    {/*<!-- Sale Product Section End -->*/}
	</>
    )
    }

        </>
	)
}

export default ProductDetails